import { render } from "./CheckoutShipping.vue?vue&type=template&id=699476e8"
import script from "./CheckoutShipping.vue?vue&type=script&lang=js"
export * from "./CheckoutShipping.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__